import React from 'react'
import diamondFacialImg from "./../../../../Images/FacialPage/Diamond Glow Facial.png";

const DiamondFacialImg = () => {
  return (
    <div className="facialExtImg">
      <img src={diamondFacialImg} alt="diamondFacialImg" />
    </div>
  )
}

export default DiamondFacialImg
